<template>
  <b-row style="width:100%;">
    <b-col cols="1">
      <a :href="'#'+$route.path">
        <b-icon icon="x-circle" variant="danger" font-scale="1.5" shift-v="-4" v-b-popover.hover.right="'Delete Day'" @click="deleteOpeningHours"></b-icon>
      </a>
    </b-col>
    <b-col>
      <b-form-timepicker v-model="ophour.open_time" hour12 @hidden="updateHoursEmit"></b-form-timepicker>
    </b-col>
    <b-col>
      <b-form-timepicker v-model="ophour.close_time" hour12 @hidden="updateHoursEmit"></b-form-timepicker>
    </b-col>
    <b-col>
      <b-form-select v-model="ophour.day" :options="opdays" @input="updateHoursEmit"></b-form-select>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: 'OpeningHours',
  props: ['hour', 'days'],
  data () {
    return {
      ophour: {
        open: '',
        close: '',
        day: 0
      },
      opdays: []
    }
  },

  computed: {
  },

  methods: {
    updateHoursEmit() {
      this.$emit('update-hours-emit', this.ophour);
    },

    deleteOpeningHours() {
      this.$emit('delete-hours-emit', this.hour.id);
    }
  },

  created: function() {
    this.ophour = this.hour;
    this.opdays = this.days;
  }
}
</script>

<style>

</style>
